import React, { useEffect, useState,useContext } from "react";
import { Button, Row, Col, Radio, Tag, Spin } from "antd";
import { SaveOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Paper,
  TextField,
  Box,
  Typography,
  Divider,
  Button as MUIButton,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { URL as BASE_URL } from "../config";
import { LoaderContext } from "../Components/dashboard";
const themeColor = "#4B0082";

export default function SongSubTypeForm() {
  const { setLoading } = useContext(LoaderContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [mode, setMode] = useState(id ? "edit" : "create");

  const [subTypeName, setSubTypeName] = useState("");

const [saving, setSaving] = useState(false);

  const [mainTypes, setMainTypes] = useState([]);
  const [fkMainTypeId, setFkMainTypeId] = useState(null);

  const [isActive, setIsActive] = useState(1);

  const [photoFile, setPhotoFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [removeImage, setRemoveImage] = useState(0);


  useEffect(() => {
  let isMounted = true;
  const startTime = Date.now();

  setLoading(true); 

  const init = async () => {
    if (id) {
      await fetchDetails(); 
    }

    const elapsed = Date.now() - startTime;
    const remaining = 1500 - elapsed;

    setTimeout(() => {
      if (isMounted) {
        setLoading(false); 
      }
    }, remaining > 0 ? remaining : 0);
  };

  init();

  return () => {
    isMounted = false;
  };
}, [id]);
  useEffect(() => {
    fetchMainTypes();
  }, []);

  useEffect(() => {
    if (id && mainTypes.length > 0) {
      fetchDetails();
      setMode("edit");
    }
  }, [id, mainTypes]);

    const fetchMainTypes = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/songmaintype`);
      const list = res.data.data.filter((i) => i.isActive === 1);
      setMainTypes(list);
    } catch {
      toast.error("Failed to load main types");
    }
  };

  
  const fetchDetails = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/songsubtype/${id}`
      );
      const d = res.data.data;

      setSubTypeName(d.subTypeName || "");
      setFkMainTypeId(d.fkMainTypeId || null);
      setIsActive(d.isActive ?? 1);

      if (d.subTypePhoto) {
        setPreview(`${BASE_URL}${d.subTypePhoto}`);
      }
    } catch {
      toast.error("Failed to load subtype");
    } finally {
      
    }
  };

  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

const removeFile = () => {
  setPhotoFile(null);
  setPreview("");
  setRemoveImage(1); 
};


  const clearForm = () => {
    setSubTypeName("");
    setFkMainTypeId(null);
    setIsActive(1);
    setPhotoFile(null);
    setPreview("");
  };

  const handleSave = async () => {
    if (saving) return;
    if (!subTypeName.trim() || !fkMainTypeId) {
      toast.error("Required fields missing");
      return;
    }

    try {
       setSaving(true);
      const fd = new FormData();
      fd.append("subTypeName", subTypeName);
      fd.append("fkMainTypeId", fkMainTypeId);
      fd.append("isActive", isActive);
      if (photoFile) fd.append("subTypePhoto", photoFile);
if (removeImage === 1) {
  fd.append("removeImage", "1");
}

      if (mode === "edit") {
        await axios.patch(
          `${BASE_URL}/songsubtype/${id}`,
          fd
        );
        toast.success("Updated successfully");
        clearForm();
        setMode("create");
        window.history.replaceState({}, "", "/dashboard/subtype");
      } else {
        await axios.post(
          `${BASE_URL}/songsubtype`,
          fd
        );
        toast.success("Created successfully");
        clearForm();
      }
    } catch {
      toast.error("Save failed");
    }  finally {
    setSaving(false); 
  }
  };


  return (
    <Box sx={{ p: { xs: 0.1, md: 1 } }}>
      <Paper elevation={3} sx={{ p: { xs: 1, md: 3 }, borderRadius: 3 }}>
       
        <Box display="flex" justifyContent="center" mb={2}>
          <Box
            sx={{
           background: `linear-gradient(90deg, ${themeColor}, #b66aec)`,
              px: { xs: 2.5, md: 4 },
              py: { xs: 0.8, md: 1.1 },
              borderRadius: "8px 22px 8px 22px",
              boxShadow: "0 6px 16px rgba(255,92,110,0.35)"


            }}
          >
             <Typography
                          sx={{
                            fontSize: { xs: "14px", md: "18px" },
                            fontWeight: 900,
                            color: "#fff",
                            letterSpacing: "0.7px",
                            textTransform: "uppercase",
                          }}
                        >
                          Song Sub Type
                        </Typography>
          </Box>
        </Box>

        <Divider
          sx={{
            mb: 3,
            background: `linear-gradient(90deg, transparent, ${themeColor}, transparent)`,
            height: "2px",
          }}
        />

       
        <Row gutter={[16, 16]} align="middle">
         
          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor,fontSize: { xs: "13px", md: "14px" } }}>
              Sub Type Name
            </Typography>
            <TextField
              size="small"
              fullWidth
              value={subTypeName}
              onChange={(e) => setSubTypeName(e.target.value)}
                  sx={{
  "& .MuiOutlinedInput-root": {
    minHeight: 40,               
    "& fieldset": { borderColor: "#ccc" },
    "&:hover fieldset": { borderColor: "#aaa" },
    "&.Mui-focused fieldset": { borderColor: "#aaa" },
  },

  "& .MuiInputBase-input": {
    fontSize: "13px",              
    padding: "8.5px 12px",         
    boxSizing: "border-box",
  },
}}

            />
          </Col>

       
          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={0.5} sx={{ color: themeColor,fontSize: { xs: "13px", md: "14px" } }}>
              Main Type
            </Typography>

            <Autocomplete
              options={mainTypes}
              getOptionLabel={(option) => option.mainTypeName || ""}
              value={
                mainTypes.find(
                  (m) => m.mainTypeId === fkMainTypeId
                ) || null
              }
              onChange={(e, newValue) => {
                if (newValue) {
                  setFkMainTypeId(newValue.mainTypeId);
                } else {
                  setFkMainTypeId(null);
                }
              }}
                           ListboxProps={{
    sx: {
      maxHeight: 180,
      overflowY: "auto",
      fontSize: "13px",

      "&::-webkit-scrollbar": {
        width: "5px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#bbb",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
      },
    },
  }}
  sx={{
    "& .MuiOutlinedInput-root": {
      minHeight: 40,                
      "& fieldset": { borderColor: "#ccc" },
      "&:hover fieldset": { borderColor: "#aaa" },
      "&.Mui-focused fieldset": { borderColor: "#aaa" },
    },
    "& .MuiInputBase-input": {
      fontSize: "13px",
      padding: "8.5px 12px",        
    },
  }}
              renderInput={(params) => (
                <TextField
                
                  {...params}
                  size="small"
                  placeholder="Select main type"
                />
              )}
            />
          </Col>

          
          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={1} sx={{ color: themeColor ,fontSize: { xs: "13px", md: "14px" }}}>
              Status
            </Typography>
            <Radio.Group
              value={isActive}
              onChange={(e) => setIsActive(e.target.value)}
            >
              <Radio value={1}>
                <Tag color="green">Active</Tag>
              </Radio>
              <Radio value={0}>
                <Tag color="red">Deactive</Tag>
              </Radio>
            </Radio.Group>
          </Col>

          {/* UPLOAD */}
          <Col xs={24} sm={12} md={8}>
            <Typography fontWeight={600} mb={1} sx={{ color: themeColor,fontSize: { xs: "13px", md: "14px" } }}>
              Upload Photo
            </Typography>

            <Box display="flex" alignItems="center" gap={1.5}>
              <input
                hidden
                id="sub-photo"
                type="file"
                accept="image/*"
                onChange={handleFileChange}
              />
              <label htmlFor="sub-photo">
                <MUIButton variant="outlined"
                sx={{ fontWeight: 600, fontSize: { xs: "12px", md: "14px" }, borderColor: "#aaa", color: "#8b8989", "&:hover": { borderColor: themeColor, background: "rgba(255,92,110,0.08)" } }} component="span">
                  Upload Photo
                </MUIButton>
              </label>

              {preview && (
                <Box position="relative">
                  <img
                    src={preview}
                    alt="preview"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: 6,
                      objectFit: "cover",
                      border: `1px solid ${themeColor}`,
                    }}
                  />
                  <CloseIcon
                    onClick={removeFile}
                    sx={{
                      position: "absolute",
                      top: -6,
                      right: -6,
                      cursor: "pointer",
                      background: "#fff",
                      borderRadius: "50%",
                      fontSize: 16,
                      color: themeColor,
                    }}
                  />
                </Box>
              )}
            </Box>
          </Col>
        </Row>

      
        <Box display="flex" justifyContent="end" mt={4} gap={1.5}>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            onClick={handleSave}
             loading={saving}          
  disabled={saving}
            style={{ background: themeColor, borderRadius: 25 }}
          >
            {mode === "edit" ? "Update" : "Save"}
          </Button>

          <Button
            icon={<InfoCircleOutlined />}
            onClick={() => navigate("/dashboard/subtypelist")}
            style={{ borderRadius: 25 ,color:"red",borderColor:"red"}}
          >
            Details
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
